import React from "react";
import { withRouter } from "react-router-dom";
import { Icon } from "aible";

import styles from "./style.module.css";

class BreadCrumb extends React.PureComponent {
  render() {
    const { children, history, route, className, disable, staticContext, ...retProps } = this.props;
    return (
      <div className={styles.bWrapper}>
        <div
          {...retProps}
          className={styles.bLabel + " " + (route && !disable ? styles.click : "") + " " + (className ? className : "")}
          onClick={route && !disable ? () => history.push(route) : undefined}
        >
          {children}
        </div>
        <div className={styles.bIcon}>
          <Icon type={"chevronRight"} />
        </div>
      </div>
    );
  }
}

class Crumb extends React.PureComponent {
  render() {
    const {} = this.props;
    return <div>Hello World 1</div>;
  }
}

export default withRouter(BreadCrumb);
